<template>
  <div id="speakers">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto" v-if="true">
          <!-- <li class="nav-item">
            <el-button
              type="warning"
              icon="fas fa-flag"
              round
              size="mini"
              @click="
                $store.state.standcheckins.filter.standIDs = [scope.row.id];
                checkinModal = true;
              "
            >
              {{ this.$t('event.buttons.checkinList') }}</el-button
            >
          </li> -->
          <li class="nav-item">
            <el-button type="warning" icon="fas fa-map-marker-alt" @click="saloonModal = true" round size="mini">{{ this.$t("event.tags.saloons") }}</el-button>
          </li>
          <!-- <li class="nav-item">
            <a
              href="javascript:;"
              @click="
                $store.state.standcheckins.filter.standIDs = [scope.row.id];
                checkinModal = true;
              "
              class="navbar-nav-link"
            >
              {{ this.$t('event.buttons.checkinList') }}
              <i class="fas fa-flag ml-1"></i>
            </a>
          </li> -->

          <!-- <li class="nav-item">
            <a href="javascript:;" @click="saloonModal = true" class="navbar-nav-link">
              {{ this.$t('event.tags.saloons') }}
              <i class="icon-map4 ml-1"></i>
            </a>
          </li> -->
          <li class="nav-item">
            <el-tooltip class="item" effect="dark" :content="$t('contentManagement.stands.searchFilter')" placement="top">
              <el-button icon="fas fa-search" :type="$store.state.stands.filter.searchTerm != '' && $store.state.stands.filter.searchTerm != null ? 'success' : ''" size="small" circle @click="isFilterEnabled = !isFilterEnabled"></el-button>
            </el-tooltip>
          </li>
          <!-- <li class="nav-item">
            <a href="javascript:;" class="navbar-nav-link" @click="isFilterEnabled = !isFilterEnabled">
              {{ this.$t('event.components.participants.navbar.filterRecord') }}
              <i class="fas fa-search ml-1" :class="$store.state.stands.filter.searchTerm != null && $store.state.stands.filter.searchTerm != '' ? 'animate__animated animate__pulse animate__infinite text-info' : ''"></i>
            </a>
          </li> -->
          <li class="nav-item">
            <el-button type="primary" icon="fas fa-plus" size="mini" round @click="createStand">{{ $t("contentManagement.stands.addStand") }}</el-button>
          </li>
          <!-- <li class="nav-item">
            <a
              href="javascript:;"
              class="navbar-nav-link"
              @click="
                updateForm = null;
                modalVisible = true;
              "
            >
              {{ this.$t('event.components.participants.navbar.add') }}
              <i class="icon-plus3 ml-1"></i>
            </a>
          </li> -->
        </ul>
      </portal>
      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="card card-collapsed filter-card">
            <div class="card-header">
              <div class="card-title-container">
                <h5 class="card-title">{{ $t("contentManagement.stands.filter") }}</h5>
                <span>{{ $t("contentManagement.stands.filterMsg") }}</span>
              </div>
              <div class="header-elements">
                <el-button-group>
                  <el-button @click="$store.state.stands.filter.searchTerm = ''" icon="el-icon-refresh-right" size="mini" round>{{ $t("event.buttons.reset") }}</el-button>
                  <el-button type="warning" icon="el-icon-close" size="mini" @click="isFilterEnabled = false" round>{{ $t("event.buttons.close") }}</el-button>
                </el-button-group>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-12">
                  <el-input clearable v-model="$store.state.stands.filter.searchTerm" :placeholder="$t('contentManagement.stands.placeholderStand')"></el-input>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ this.$t("event.menu.exhibitors.title") }}</h5>
              <span v-if="$store.state.stands.items.length > 0" v-html="$t('totalContent', [filter.total])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refreshList" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
          <!-- burayı kapat -->
          <div class="card-body" v-if="false">
            <upgrade-overlay height="200px"></upgrade-overlay>
          </div>
          <div class="card-body" v-else-if="$store.state.stands.items.length > 0">
            <div class="custom-grid-table-header stand-grid-template-header">
              <span><i v-show="loading == 'loadingList'" class="el-icon-loading"></i></span>
              <span>{{ $t("contentManagement.stands.stand") }}</span>
              <span>{{ $t("contentManagement.stands.broadcast") }}</span>
              <span></span>
            </div>
            <draggable class="stand-grid-template-list" handle=".el-icon-s-grid" :list="$store.state.stands.items" @end="changeSort">
              <div class="item" v-for="item in $store.state.stands.items" :key="item.id + '-stand-list'" :class="{ passive: !item.isActive }">
                <div>
                  <i class="el-icon-loading burger" v-if="loading == item.id + 'ItemToggle'"></i>
                  <i class="el-icon-s-grid burger" v-else></i>
                </div>
                <div class="stand-grid-item-img-title">
                  <span class="item-color-container">{{ item.orderNO }}</span>
                  <div class="img" :style="'background-image:url(' + $imageus + item.image + '?width=112&height=50&mode=cover)'"></div>
                  <div class="stand-grid-item-title">
                    {{ item.title }} 
                  </div>
                </div>
                <div><el-switch v-model="item.isActive" @change="statusChanged(item.id)"></el-switch></div>
                <div class="btn-list">
                  <el-tooltip effect="dark" :content="$t('event.table.qr')" placement="top">
                    <el-button type="success" icon="fas fa-qrcode" circle size="mini" @click="openQr(item.id)"></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="$t('event.buttons.checkinList')" placement="top">
                    <el-button
                      type="warning"
                      icon="fas fa-flag"
                      circle
                      size="mini"
                      @click="
                        $store.state.standcheckins.filter.standIDs = [item.id];
                        checkinModal = true;
                      "
                    ></el-button>
                  </el-tooltip>

                  <el-tooltip effect="dark" :content="$t('event.table.edit')" placement="top">
                    <el-button
                      type="primary"
                      icon="fas fa-pen"
                      circle
                      size="mini"
                      @click="
                        standId = item.id;
                        modalVisible = true;
                      "
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="$t('event.table.delete')" placement="top">
                    <el-popconfirm @confirm="deleteItem(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                      <el-button slot="reference" type="danger" :loading="loading == 'deleteItem-' + item.id" icon="fas fa-trash" circle size="mini"></el-button>
                    </el-popconfirm>
                  </el-tooltip>
                </div>
              </div>
            </draggable>
          </div>
          <div v-else>
            <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-expo-lottie'" :title="$t('event.menu.exhibitors.title')" @btnAdd="createStand()" @btnRefresh="refreshList()" :buttonAdd="true" :buttonRefresh="true" :loading="loading" />
          </div>
          <div class="card-footer" v-if="true">
            <el-pagination v-if="$store.state.stands.items.length > 0" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="filter.page" :page-sizes="[20, 30, 40, 50, 100, 200, 500]" :page-size="100" layout="total, sizes, prev, pager, next" :total="filter.total"></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible" :title="standId != null ? $t('contentManagement.stands.editStand') : $t('contentManagement.stands.addStand')" class="large" center modal-append-to-body destroy-on-close>
      <StandAddUpdate @closeDialog="modalVisible = false" @deleteMe="deleteItem" v-if="modalVisible" :standId="standId" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="saloonModal" :title="$t('event.tags.halls')" class="large" center modal-append-to-body destroy-on-close>
      <StandSaloons @closeDialog="saloonModal = false" v-if="saloonModal" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="checkinModal" :title="$t('event.buttons.checkinList')" class="xlarge" center modal-append-to-body destroy-on-close>
      <StandCheckins @closeDialog="checkinModal = false" />
    </el-dialog>
  </div>
</template>

<script>
import StandAddUpdate from "../../components/StandAddUpdate";
import ExcelImport from "../../components/ExcelImport";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import draggable from "vuedraggable";
import StandSaloons from "../../components/StandSaloons";
import StandCheckins from "../../pages/event/StandCheckins";
import $ from "jquery";
export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.expo")
    };
  },
  components: {
    draggable,
    StandAddUpdate,
    ExcelImport,
    PageCountInfo,
    StandSaloons,
    StandCheckins
  },
  name: "Speakers",
  data() {
    return {
      createForm: {
        id: null,
        title: "New booth",
        cover: "https://holacon.s3.eu-central-1.amazonaws.com/public/default/default-cover.png",
        image: "https://holacon.s3.eu-central-1.amazonaws.com/public/default/default-company.png",
        surveysID: [],
        saloonID: null,
        detail: "...",
        orderNO: 1,
        isActive: true,
        enableCustomTags: false,
        customTags: [],
        managers: [],
        checkInTypes: [],
        location: {
          city: "Istanbul",
          venue: "...",
          country: "Turkey",
          latitude: "0",
          longtitude: "0",
          address: "..."
        },
        gallery: [],
        links: []
      },
      loading: false,
      listShort: null,
      modalVisible: false,
      standId: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "expo",
      galleryModal: false,
      saloonModal: false,
      checkinModal: false
    };
  },
  methods: {
    async createStand() {
      var res = await axios.post("stand/addorupdate", this.createForm);
      if (!res.data.alert.hasError) {
        this.standId = res.data.data.item.id;
        this.modalVisible = true;
        await this.$store.dispatch("getStands");
      }
    },
    openQr(id) {
      window.open("https://api.holacon.com/v2/Home/GetQRImage?QRText=" + id, "_blank");
    },
    handleSizeChange(take) {
      this.$store.commit("setStandTake", take);
    },
    async deleteItem(id) {
      this.loading = "deleteItem-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("deleteStand", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getStands");
        }
        this.loading = false;
      }, 500);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setStandPage", page);
    },
    async statusChanged(id) {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = id + "ItemToggle";
      await this.$store.dispatch("toggleStand", id);
      this.listShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedStands", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    },

    async refreshList() {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = "loadingList";
      await this.$store.dispatch("getStands");
      this.listShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
    },
    async changeSort() {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = "loadingList";
      this.listShort = setTimeout(async () => {
        var payload = [];
        this.$store.state.stands.items.map(x => {
          payload.push(x.id);
        });
        await this.$store.dispatch("saveStandOrder", payload);
        await this.$store.dispatch("getStands");
        this.loading = false;
      }, 500);
    }
  },
  async mounted() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.$store.dispatch("getStandSaloons");
      await this.$store.dispatch("getStands");
      this.loading = false;
    }, 500);
  },
  created() {},
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    filter() {
      return this.$store.state.stands.filter;
    },
    skip() {
      return (this.$store.state.stands.filter.page - 1) * this.$store.state.stands.filter.take;
    },
    take() {
      return this.skip + this.$store.state.stands.items.length;
    }
  },
  watch: {
    "$store.state.stands.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getStands");
      }, 500);
    }
  }
};
</script>
<style lang="less" scoped>
.stand-grid-template-header {
  grid-template-columns: 36px 1fr 90px 170px;
}

.item-color-container {
  padding: 5px 10px;
  width: max-content;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.8);
  font-weight: 600;
  color: #505763;
  font-size: 13px;
}
.stand-grid-template-list {
  .item {
    margin-bottom: 8px;
    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      cursor: grab;
      &.me {
        color: #ccc;
      }
    }
    .btn-list {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      gap: 0.2rem;
      .el-button {
        margin: 0;
      }
    }
    padding: 10px;
    gap: 0.5rem;
    align-items: center;
    display: grid;
    border-radius: 8px;
    grid-template-columns: 36px 1fr 90px 170px;
    background-color: #f1f1f1;

    &:last-child {
      margin-bottom: unset;
    }
    &.passive {
      background-color: #fff2f2 !important;
    }
    .stand-grid-item-img-title {
      display: flex;
      gap: 1rem;
      font-weight: 500;
      align-items: center;
      .stand-grid-item-title {
        font-weight: bold;
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
      }

      & > .img {
        border-radius: 8px;
        width: 112px;
        height: 50px;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        overflow: hidden;
        border: 3px solid white;
      }
    }
  }
}
</style>
<style lang="less">
.modal-base-mid {
  min-width: 1140px;
}
.modal-base-small {
  min-width: 550px;
}
.fas fa-qrcode {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/Stands.vue